"use client";
import getAvailability from "../utils/getAvailability";
import ProductAvailability from "./ProductAvailability";
import ProductPriceInfo from "./ProductPriceInfo";
import { Link } from "../../../navigation";

export default function ProductVariantCard({
  invariant,
  variant = "-",
  product,
  active,
}: {
  invariant?: boolean;
  variant?: string;
  product: any;
  active?: boolean;
}) {
  const { availability, earliestDeliveryDate } = getAvailability({
    stocks: product?.simulatedStocks,
    dispatches: product?.simulatedDispatches,
  });

  const inputId = `radio-${product._id}-${variant}`;

  return (
    <Link
      className="radio-btn-group"
      href={product?.texts?.slug ? `/product/${product?.texts?.slug}` : "#"}
      prefetch={false}
      scroll={false}
      shallow={true}
    >
      <input
        type="radio"
        id={inputId}
        name={variant}
        value={product._id}
        defaultChecked={active}
      />
      <label htmlFor={inputId} className="radio-btn">
        <div className="d-flex align-items-center gap-4 justify-content-between">
          <span>
            <div>{variant}</div>
          </span>
          {!invariant && (
            <span className="flex-shrink-0">
              <ProductAvailability
                availability={availability}
                earliestDeliveryDate={earliestDeliveryDate}
              />
            </span>
          )}
        </div>
        {!invariant && (
          <div className="d-flex align-items-center gap-4 justify-content-between">
            <ProductPriceInfo productId={product._id} appearance="inline" />
          </div>
        )}
      </label>
    </Link>
  );
}
